export default __webpack_public_path__ + "static/media/faceta_how_it_works.684c33db.mp4";